import * as Yup from 'yup';

const schema = Yup.object().shape({
  Email: Yup.string()
    .required('Digite um email válido')
    .email('Digite um email válido'),
});

export default schema;
